// Thin wrapper around the global functions exposed by /public/SigWebTablet.js
// (Topaz SigWeb v1.0.4.0). These globals require the Topaz "SigWeb" service to
// be installed on the client machine and a Topaz signature pad to be connected.

const w = () => window;

export function isSigWebInstalled() {
  try {
    return typeof w().IsSigWebInstalled === "function" && !!w().IsSigWebInstalled();
  } catch (e) {
    return false;
  }
}

let _timer = null;

// Start live capture: the pad strokes are drawn onto the given canvas in real time.
export function startCapture(canvas) {
  const ctx = canvas.getContext("2d");
  try {
    w().SetTabletState(0, _timer);
    w().SetJustifyMode(0);
    w().ClearTablet();
    _timer = w().SetTabletState(1, ctx, 50);
    return true;
  } catch (e) {
    console.error("Topaz startCapture failed", e);
    return false;
  }
}

export function stopCapture() {
  try {
    if (_timer) {
      w().SetTabletState(0, _timer);
      _timer = null;
    }
  } catch (e) {
    console.error("Topaz stopCapture failed", e);
  }
}

export function clearTablet() {
  try {
    w().ClearTablet();
  } catch (e) {
    console.error("Topaz clearTablet failed", e);
  }
}

export function numberOfPoints() {
  try {
    return parseInt(w().NumberOfTabletPoints(), 10) || 0;
  } catch (e) {
    return 0;
  }
}

// Resolve a base64 PNG data URL of the captured signature.
export function getSignatureImage(width = 500, height = 160, penWidth = 4) {
  return new Promise((resolve, reject) => {
    try {
      w().SetImageXSize(width);
      w().SetImageYSize(height);
      w().SetImagePenWidth(penWidth);
      w().GetSigImageB64((b64) => {
        if (!b64) {
          reject(new Error("Aucune image renvoyée par le pad."));
          return;
        }
        resolve("data:image/png;base64," + b64);
      });
    } catch (e) {
      reject(e);
    }
  });
}
